import { get } from 'lodash'
import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ChainingTypeDto } from '../types/ChainingTypeDto'
import ChainingType from '../classes/ChainingType'

export class ChainingTypeApiAdapter implements ApiDataAdapter<ChainingType> {
    createClass(apiData: ChainingTypeDto): ChainingType {
        return new ChainingType(
            get(apiData, 'id',  -1),
            get(apiData, 'name', ''),
            get(apiData, 'entity_type', ''),
            get(apiData, 'is_active', true),
        )
    }
}
